import CheckoutActionType from '../../common/CheckoutActionType';

const updatedNoCovid19Confirmed = () => (dispatch) => {
  dispatch({ type: CheckoutActionType.SET_CONNECTION_DATE_TO_PREFERRED });
};

const Covid19Action = {
  updatedNoCovid19Confirmed
};

export default Covid19Action;



/** WEBPACK FOOTER **
 ** ./src/redux/actions/Covid19Action.js
 **/